export const translatedLabel = {
    garrison_start: "Data/Hora",
    garrison_end: "Data/Hora final",
    garrison_name: "Nome",
    garrison_team: "Equipe",
    garrison_message: "Mensagem",
    garrison_initialobservation: "Observação inicial",
    garrison_place: "Local pré-cadastrado",
    garrison_finalized: "Encerrada",
    garrison_has_mobile: "Login via app",
    garrison_created_by_mobile: "Cadastrado via app",
    garrison_intendedfunction: "Função destinada",
    sectors: "Setor",
    animals: "Animais"
};

export const outputOrder = [
    "garrison_start",
    "garrison_has_mobile",
    "garrison_created_by_mobile",
    "garrison_finalized",
    "garrison_name",
    "garrison_leaderid",
    "garrison_team",
    "garrison_intendedfunction",
    "garrison_place",
    "garrison_sectors",
    "sectors",
    "garrison_initialobservation",
    "animals",
    "garrison_status",
    "garrison_composition"
];

export const ignoredLabels = [
    "garrison_id",
    "garrison_status"
];

export const intendedFunctionValue = (value) => {
    switch (value) {
        case "ADMINISTRATION":
            return "Administração";

        case "FIXED_LOCATION":
            return "Posto fixo";

        case "PATROLLING":
            return "Patrulhamento";

        default:
            return value ?? "";
    }
};

export const formatIntegrants = (integrants) => {
    if (!integrants) return "";

    return Object.values(integrants)
        .map(item => {
            let name;

            if (item?.contingent_id?.namewar) {
                name = item.contingent_id.namewar;
            } else if (item?.contingent?.namewar) {
                name = item.contingent.namewar;
            }

            const position = item?.position;
            return `${name} - ${position}`;
        }).join(", ");
};

export const formatAnimals = (animalIds, animals) => {
    if (!animalIds || !animals) return "";
    return animalIds.map(id => animals.find(a => a.id === id)?.name).filter(Boolean).join(" | ");
};

export const formatSectors = (sectors) => {
    if (!sectors?.length) return "";
    return sectors.join(", ");
};

export const formatArrayString = (value) => {
    if (typeof value !== "string") return value;

    try {
        const parsed = JSON.parse(value);
        if (Array.isArray(parsed)) {
            return parsed.join(", ");
        }
    } catch {}

    return value;
};

export const formatBoolean = (value) => {
    if (value === true) return "SIM";
    if (value === false) return "NÃO";
    return value;
};